module.exports = __webpack_public_path__ + "static/media/stijn-bessem-case-creative-04.84bdfc8c.jpg";